  
<div *ngIf="isLoading | async" class="overlay">
    <div class="container">
        <div class="row">
          <div *ngIf="!sharedDataService.showLexusLoader" id="loader">
              <img src="../../../../../assets/images/loader.svg" class="show-in-light" alt="loader" height="200" width="200">
              <img src="../../../../../assets/images/loader-night.svg" class="show-in-night" alt="loader" height="200" width="200">
          </div>
          <div *ngIf="sharedDataService.showLexusLoader" id="loader">
            <img src="../../../../../assets/images/lexus_loader.svg"  alt="loader" height="200" width="200">
        </div>
        </div>
      </div>
</div>